import React, { lazy } from "react";

const AboutPage = lazy(() => import("../pages/AboutPage"));
const HomePage = lazy(() => import("../pages/HomePage"));
const ProjectsPage = lazy(() => import("../pages/ProjectsPage"));
const ServicesPage = lazy(() => import("../pages/ServicesPage"));
const ContactPage = lazy(() => import("../pages/ContactPage"));

export const PAGE_LIST = Object.freeze([
  {
    name: 'Home',
    path: '/',
    component: <HomePage />
  },
  {
    name: 'About',
    path: '/about',
    component: <AboutPage />
  },
  {
    name: 'Projects',
    path: '/projects',
    component: <ProjectsPage />
  },
  {
    name: 'Contact',
    path: '/contact',
    component: <ContactPage />
  },
  // {
  //   name: 'Services',
  //   path: '/services',
  //   component: <ServicesPage />
  // }
]);